export default {
	loading    : false,
	ranks_month: [],
	ranks_full : []
}
